{
  "novel_manuscript": "Manuskript",
  "novel_notes": "Notizen zur Geschichte",
  "novel_main_characters": "Hauptcharaktere",
  "novel_secondary_characters": "Nebencharaktere",
  "novel_plot": "Parzelle"
}
